
function carouselDraggable() {
  $('.carousel').each( function() { // Handle each instance of carousel separately

    // Ref: https://stackoverflow.com/questions/5766297/handle-click-and-drag-movement-to-scroll-horizontally-with-mootools-or-jquery#answer-5839943
    var x,left,down,parentLinkElement,parentLink;
    var scrollPreventdefaultMargin = 20; // Distance to drag before links get disabled
    var carousel = $(this).find('.carousel-track');

    carousel.mousedown(function(event){
      if (event.which === 1) { // on left-click only
        down = true;
        x = event.pageX; // Get X position of cursor
        left = carousel.scrollLeft(); // Get scroll position of carousel
        if (event.target.closest('a')) {
          parentLinkElement = event.target.closest('a'); // Determine link element
          parentLink = parentLinkElement.getAttribute('href'); // Get link URL
        }
        event.preventDefault(); // Important - Cancels left-click specific mousedown register
      }

      // Mousmove within mousedown
      $("body").mousemove(function(e){
        if(down == true){ // Drag
          var newX = e.pageX;
          if (Math.abs(x-newX) > scrollPreventdefaultMargin) { // if dragged more than set margin
            if (parentLinkElement) {
              parentLinkElement.setAttribute('href', 'javascript:;'); // Temporarily remove link URL
            }
            carousel.addClass('dragging');
          }
          carousel.scrollLeft(left - newX + x); // Scroll carousel with drag
        }
      });

    });

    $('body').on('mouseup mouseleave', function(event) { // Reset on mouseup OR when the mouse leaves the window
      if (parentLinkElement) {
        setTimeout( function() {
          parentLinkElement.setAttribute('href', parentLink); // Reset original link URL
        }, 20);
      }
      carousel.removeClass('dragging');
      down = false; // Reset to default behaviour
    });

  }); // end foreach
}


function carouselCentre() {
  $('.carousel').each( function() {
    var carousel = $(this).find('.carousel-track');
    var carouselWidth = carousel.outerWidth();
    var columnGap = parseInt(carousel.css('grid-column-gap'));
    var itemsCollectiveWidth = 0;

    // Adjust carousel track width to fit perfectly in viewport, with or without scrollbar
    // This works with specific styles at > 1200px width
    if( window.innerWidth >= 1200 ) {
      let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth; // Ref: https://muffinman.io/get-scrollbar-width-in-javascript/
      carousel.css('width', window.innerWidth - (scrollbarWidth/2));
    } else {
      carousel.css('width', 'auto');
    }

    carousel.children().each( function(i) { // target direct children (could be card, article, etc.)
      var thisCardWidth = $(this).outerWidth();
      itemsCollectiveWidth = itemsCollectiveWidth + thisCardWidth + columnGap; // add card width plus column gap
    });
    itemsCollectiveWidth -= columnGap; // minus column gap for final item
    // console.log("itemsCollectiveWidth: " + itemsCollectiveWidth);
    // console.log("carouselWidth: " + carouselWidth);
    if (itemsCollectiveWidth <= carouselWidth) {
      carousel.addClass('center-items');
    } else {
      carousel.removeClass('center-items');
    }
  });
}


if ($('.carousel').length) {
  carouselDraggable();
  carouselCentre();
  $(window).resize ( function() {	carouselCentre(); });
}
